export default function formatPercentage(percentage: number | null) {
    if (percentage === null || isNaN(percentage)) {
        return null
    }
    return percentage.toFixed(1)
}
